import { render, staticRenderFns } from "./location_list.vue?vue&type=template&id=23a8dd5e"
import script from "./location_list.vue?vue&type=script&lang=js"
export * from "./location_list.vue?vue&type=script&lang=js"
import style0 from "./location_list.vue?vue&type=style&index=0&id=23a8dd5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports